/**
 * Created by Kieran on 21/10/2017.
 */

import config from '../../config'
import axios from 'axios'

let ProviderApi = {
  getProvider() {
    return axios.get(config.apiUrl + 'user/provider')
  }
};

export default ProviderApi;



// WEBPACK FOOTER //
// ./src/api/Provider/index.js